import { useTranslation } from 'react-i18next';


export default function DietarySection({
    dietary,
    onDietaryChange,
    lang
}) {

    const renderQuestion = (title, field) => (

        <div className="diet-question" style={{ width: "100%" }}>

            <label className="fontmontserrat">{t(title)}</label>

            <div>

                <label style={{ marginRight: "15px" }} className="fontmontserrat">

                    <input
                        type="radio"
                        checked={dietary[field].enabled}
                        onChange={() => onDietaryChange(field, "enabled", true)}
                        name={`question${field}`}
                        required
                        style={{ marginRight: "5px" }}
                    />

                    {t("Sí")}

                </label>

                <label className="fontmontserrat">

                    <input
                        type="radio"
                        checked={!dietary[field].enabled}
                        onChange={() => onDietaryChange(field, "enabled", false)}
                        name={`question${field}`}
                        required
                        style={{ marginRight: "5px" }}
                    />

                    {t("No")}

                </label>

            </div>

            {dietary[field].enabled && (

                <textarea
                    rows="3"
                    placeholder={t("Indique nombres y detalles...")}
                    value={dietary[field].details}
                    onChange={(e) =>
                        onDietaryChange(field, "details", e.target.value)
                    }
                    required
                    className="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-input u-input-rectangle"
                />

            )}

        </div>

    );

    const { t } = useTranslation();

    return (

        <>

            <h2 className="u-align-center u-form-group u-form-text u-label-none u-text u-text-7 fontmontserrat">{t("Requisitos dietéticos")}</h2>

            {renderQuestion(
                "¿Algún miembro del grupo requiere una dieta específica (vegetariana, vegana, kosher, halal, etc.)?",
                "specialDiet"
            )}

            {renderQuestion(
                "¿Algún miembro del grupo tiene alergias alimentarias?",
                "allergies"
            )}

            {renderQuestion(
                "¿Algún miembro del grupo tiene alimentos que no le gusten especialmente?",
                "dislikes"
            )}

        </>

    );

}
